import React from 'react';

const OurCommunity = () => {
   const communityImages = [
      {
         id: 1,
         src: "https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&q=80&w=500",
         alt: "Groupe d'étudiants collaborant",
         category: "étudiants"
      },
      {
         id: 2,
         src: "https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&q=80&w=500",
         alt: "Tuteur accompagnant des apprenants",
         category: "tuteurs"
      },
      {
         id: 3,
         src: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=500",
         alt: "Parents participants à un événement",
         category: "parents"
      },
      {
         id: 4,
         src: "https://images.unsplash.com/photo-1581092921461-eab62e97a780?auto=format&fit=crop&q=80&w=500",
         alt: "Laboratoire de fabrication moderne",
         category: "labs"
      },
      {
         id: 5,
         src: "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&q=80&w=500",
         alt: "Groupe de collégiens en apprentissage",
         category: "collégiens"
      },
      {
         id: 6,
         src: "https://images.unsplash.com/photo-1546410531-bb4caa6b424d?auto=format&fit=crop&q=80&w=500",
         alt: "Atelier pratique en cours",
         category: "workshop"
      },
      {
         id: 7,
         src: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=500",
         alt: "Mentors guidant des étudiants",
         category: "mentors"
      },
      {
         id: 8,
         src: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=500",
         alt: "Session de formation collaborative",
         category: "formation"
      }
   ];

   const features = [
      {
         title: "Communauté de Makers",
         description: "Plusieurs cohortes ont déjà rejoint la communauté de Makers à travers stages, bootcamps et tutorat.",
         icon: "👥"
      },
      {
         title: "Partenariats",
         description: "Partenariats avec des fablabs, universités et écoles locales et internationales.",
         icon: "🤝"
      },
      {
         title: "Collaboration",
         description: "Une communauté collaborative où chacun peut apprendre, créer et partager.",
         icon: "✨"
      }
   ];

   return (
      <section className="py-12 md:py-16 lg:py-24 px-4 bg-white">
         <div className="max-w-7xl mx-auto">
            <h2 className="text-title font-bold text-center text-dark-1 mb-4">
               Notre <span className="text-blue-1">Communauté</span>
            </h2>
            <p className="text-center text-subtitle text-gray-600 mb-12 max-w-3xl mx-auto">
               Découvrez notre écosystème de Makers passionnés qui apprennent, innovent et créent ensemble.
            </p>

            {/* Mosaïque de photos - Version Desktop */}
            <div className="hidden md:grid grid-cols-4 gap-4 mb-16">
               {communityImages.map((image, index) => (
                  <div
                     key={image.id}
                     className={`
                rounded-lg overflow-hidden shadow-md transition-transform duration-300 hover:scale-105
                ${index === 0 ? 'row-span-2' : ''}
                ${index === 3 ? 'col-span-2' : ''}
              `}
                  >
                     <img
                        src={image.src}
                        alt={image.alt}
                        className="w-full h-full object-cover"
                        style={{ minHeight: index === 0 ? '400px' : '200px' }}
                     />
                  </div>
               ))}
            </div>

            {/* Mosaïque de photos - Version Mobile */}
            <div className="md:hidden grid grid-cols-2 gap-3 mb-12">
               {communityImages.slice(0, 4).map((image) => (
                  <div
                     key={image.id}
                     className="rounded-lg overflow-hidden shadow-md aspect-square"
                  >
                     <div className="w-full h-full bg-gradient-to-br from-red-4 to-red-600 flex items-center justify-center">
                        <span className="text-3xl">
                           {image.category === 'étudiants' && '🎓'}
                           {image.category === 'tuteurs' && '👨‍🏫'}
                           {image.category === 'parents' && '👪'}
                           {image.category === 'labs' && '🔬'}
                           {image.category === 'collégiens' && '📚'}
                           {image.category === 'workshop' && '🛠️'}
                           {image.category === 'mentors' && '🌟'}
                           {image.category === 'formation' && '💡'}
                        </span>
                     </div>
                  </div>
               ))}
            </div>

            {/* Features */}
            <div className="grid md:grid-cols-3 gap-8">
               {features.map((feature, index) => (
                  <div key={index} className="bg-white p-6 rounded-xl">
                     <div className="text-title mb-4">{feature.icon}</div>
                     <h3 className="text-xl font-semibold text-dark-1 mb-3">{feature.title}</h3>
                     <p className="text-gray-600 text-subtitle">{feature.description}</p>
                  </div>
               ))}
            </div>

            {/* Call-to-action */}
            <div className="text-center mt-12">
               <a href="https://app.gonextmaker.com/auth/signup">
                  <button className="bg-red-4 hover:bg-white text-white hover:text-red-4 py-3 px-8
          rounded-full transition-colors duration-300 border-2 border-red-4 text-button">
                     Rejoindre la communauté
                  </button>
               </a>
            </div>
         </div>
      </section>
   );
};

export default OurCommunity;